<template>
  <div class="dashboard-settings">
    <h2>Settings</h2>
    <p>Coming soon...</p>
  </div>
</template>

<script>
export default {
  name: 'DashboardSettings'
}
</script>

<style scoped>
.dashboard-settings {
  padding: 24px;
}
</style> 